import { Box, styled } from '@mui/material';

const StyContentWrapper = styled(Box, {
    name: 'StyContentWrapper',
})(({ theme }) => ({
    padding: '0 2rem',
    backgroundColor: theme.palette.lightGrey,
    height: '100%',
    overflowX: 'hidden',
    flex: 1,
}));

export default StyContentWrapper;
